module.exports = __webpack_public_path__ + "cdd7c274867b0f83fad13d55932274e1.png";


//////////////////
// WEBPACK FOOTER
// ./lib/provider/resources/img/logo-perfimmo.png
// module id = 1829
// module chunks = 0